<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col-5">
				<el-row :gutter="30">
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-regn-tap-2-table-1 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-regn-tap-2-table-1>
						</sf-card>
					</el-col>
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-regn-tap-2-table-2 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-regn-tap-2-table-2>
						</sf-card>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import PcPcmRegnTap2Table1 from './PcPcmRegnTap2Table1.vue';
import PcPcmRegnTap2Table2 from './PcPcmRegnTap2Table2.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmRegnTap2Table1, PcPcmRegnTap2Table2 },
	methods: {}
};
</script>

<style></style>
